import { useSite } from '@edreamsodigeo/frontend-core';

const ukDisplayTypeSites = [
  'DE',
  'ES',
  'FR',
  'GB',
  'UK',
  'NL',
  'GOFR',
  'OPAT',
  'OPDE',
  'OPFR',
  'OPGB',
  'OPUK',
  'OPNL',
];

const useDisplayTypeBySite = () => {
  const site = useSite();

  const isUKDisplayType = () => {
    return ukDisplayTypeSites.includes(site);
  };

  return { isUKDisplayType };
};

export default useDisplayTypeBySite;
